import React from "react";
import styles from "./Teams.module.css";

const Teams = () => {
  const teamMembers = [
    {
      id: 1,
      name: "Sagar Agarwal",
      title: "Co-founder",
      subtitle: "Ex Founder, Hall IV\nHead of Product, Alt Mobility\nHead of Sales & Mkt, Grevol",
      image: require("../../../assets/landing/team/sagar-agarwal.jpg")
    },
    {
      id: 2,
      name: "Viraj Shetty",
      title: "Co-founder",
      subtitle: "12+ yrs in consulting, AI SaaS\nEx-Meta, Ex-Ernst & Young\nIndian School of Business (ISB)",
      image: require("../../../assets/landing/team/viraj-shetty.jpg.PNG")
    }
  ];

  return (
    <section className={styles.teams}>
      <div className={styles.container}>
        <h1 className={styles.title}>Meet the Team</h1>
        <p className={styles.subtitle}>
          Driven by experience. United by purpose
        </p>
        <div className={styles.teamGrid}>
          {teamMembers.map((member) => (
            <div key={member.id} className={styles.teamCard}>
              <div className={styles.imageContainer}>
                <img 
                  src={member.image} 
                  alt={member.name}
                  className={styles.memberImage}
                />
              </div>
              <div className={styles.memberInfo}>
                <h3 className={styles.memberName}>{member.name}</h3>
                <p className={styles.memberTitle}>{member.title}</p>
                {member.subtitle && (
                  <p className={styles.memberSubtitle}>{member.subtitle}</p>
                )}
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Teams;